import { ValueFormatterParams } from "ag-grid-community";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import PlusButtonIcon from "../../../../assets/images/PlusButtonIcon.svg";
import Grid from "../../../../components/Grid";
import { ColumnDef } from "../../../../components/Grid/model/Grid";
import ModalDelete from "../../../../components/ModalDelete";
import Loading from "../../../../core/common/Loading";
import { formatDateBR } from "../../../../helpers/format";
import { useModal } from "../../../../hooks/ModalContext";
import api from "../../../../services/api";
import Create from "./Create";
import { IValidacaoCRLV } from "./Create/types/types";
import Info from "./Info";
import Can from "../../../../components/Can";

// import { Continer } from './styles';

const ListValidacaoCRLV: React.FC = () => {
  const [states, setStates] = useState<any[]>([]);

  const getStates = useCallback(async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token") || localStorage.getItem("token") || localStorage.getItem("token");
      const response = await api.post(
        "/listar/estados",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setStates(response.data);
    } catch {}
  }, []);

  useEffect(() => {
    getStates();
  }, [getStates]);

  const columns = useMemo<ColumnDef[]>(() => [
    {
      field: "id_estado",
      headerName: "Estado",
      flex: 1,
      filter: true,
      filterParams: {
        selected: {
          data: states.map((state) => ({
            label: state.nome,
            value: state.id_estado,
          })),
        },
      },
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value && states.length > 0) {
          const state = states.find((s) => s.id_estado === params.value);
          return state ? state.nome : params.value;
        }
        return "---";
      },
    },
    {
      field: "ano_exercicio",
      headerName: "Ano de Exercício",
      flex: 1,
      filter: true,
    },
    {
      field: "final_placa",
      headerName: "Final da Placa",
      flex: 1,
      filter: true,
    },
    {
      field: "validade_exercicio",
      headerName: "Validade do Exercício",
      flex: 1,
      filter: true,
      filterParams: {
        dateBetween: true,
      },
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return formatDateBR(params.value);
        }
        return "---";
      },
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
  ], [states]);

  const [isRemove, setIsRemove] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRow, setSelectedRows] = useState<IValidacaoCRLV>();
  const [isView, setIsView] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const gridRef = useRef<any>();

  const { isModalOpen, closeModal, openModal } = useModal();

  const onDelete = useCallback(async (rowId?: number) => {
    try {
      setLoading(true);
      const body = {
        id_configuracao_crlv: rowId,
        id_validacao_crlv: rowId,
        id: rowId,
      };

      await api.post("/deletar/configuracaoCRLV", body);

      setLoading(false);

      setIsRemove(false);

      gridRef.current?.refresh();
    } catch {
      setLoading(false);
    }
  }, []);

  return (
    <>
      {isModalOpen && (
        <Create
          isView={isView}
          isEdit={isEdit}
          selectedRow={selectedRow}
          states={states}
          onClear={() => {
            closeModal();
            setIsEdit(false);
          }}
          onConfirm={() => {
            closeModal();
            gridRef.current?.refresh();
          }}
        />
      )}

      <Loading loading={loading} />

      {isRemove && (
        <ModalDelete
          onCancel={() => setIsRemove(!isRemove)}
          onConfirm={() => onDelete(selectedRow?.id_configuracao_crlv || selectedRow?.id_validacao_crlv || selectedRow?.id)}
          row={`Validação CRLV - ${
            states.find((s) => s.id_estado === selectedRow?.id_estado)?.nome ||
            "---"
          } - ${selectedRow?.ano_exercicio}`}
        />
      )}
      {isView && (
        <Info
          data={selectedRow}
          states={states}
          title="Conhecer - Validação CRLV"
          onClose={() => setIsView(!isView)}
        />
      )}

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">
              Validação do CRLV
            </h1>
          </div>
          <div className="mr-14">
            <Can acao="SALVAR">
            <button
              className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
              onClick={() => openModal()}
              id="btnCreate"
            >
              Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
            </button>
            </Can>
          </div>
        </div>
        <div className="flex w-full">
          <Grid
            key={states.length}
            ref={gridRef}
            columns={columns}
            filters={[]}
            pagination
            perPage={10}
            path="/listar/configuracaoCRLV"
            status={[]}
            defaultSortField="id_configuracao_crlv"
            onDelete={(data: any) => {
              setIsRemove(!isRemove);
              setSelectedRows(data);
            }}
            onView={(data: any) => {
              setSelectedRows(data);
              setIsView(!isView);
            }}
            onUpdate={(data: any) => {
              setSelectedRows(data);
              setIsEdit(!isEdit);
              openModal();
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ListValidacaoCRLV;

